import { SplitterPaneProps } from '@progress/kendo-react-layout';
import { IListItems } from '@pages-clean/admin/study/manage-panels/tab-content/panel-details/types/timeline/shared/context';
import {
    RowDataSourceTag,
    TimelineAxisType,
    TimelineDateSeriesType,
    TimelineFieldLogicalOperator,
    TimelineNumericSeriesType,
    TimelineRuleLogicalOperator,
} from 'types/graphql-global-types';
import { ILocalState } from '@contexts/local-state-context';

const getTimelinePanelListItems = (state: ILocalState | null): IListItems => {
    return {
        rowData: state!
            .cm2DataSources!.filter((datasource) => !!datasource)
            .filter(
                (datasource) =>
                    datasource?.tags &&
                    datasource.tags?.includes(RowDataSourceTag.PANEL) &&
                    datasource.table?.startsWith('SUBJECT_') &&
                    !datasource.default, // This flag will be true Calculated Fields, so we want to exclude those.
            )
            .map((datasource) => ({
                id: datasource.id ?? '',
                text: datasource.name ?? '',
            }))
            .sort((a, b) => a.text.localeCompare(b.text)),
        fields: state!
            .cm2Fields!.filter((field) => !!field && !!field.fieldType)
            .map((field) => ({
                id: field!.key ?? '',
                text: `${field!.name}`,
                fieldType: field!.fieldType!,
            }))
            .sort((a, b) => a.text.localeCompare(b.text)),
        dateSeriesTypes: [
            { id: TimelineDateSeriesType.SINGLE_DATE, text: 'Single Date' },
            { id: TimelineDateSeriesType.DATE_RANGE, text: 'Date Range' },
        ],
        numericSeriesTypes: [
            { id: TimelineNumericSeriesType.LINE, text: 'Line' },
            { id: TimelineNumericSeriesType.SCATTER, text: 'Scatter' },
        ],
        axisTypes: [
            { id: TimelineAxisType.NONE, text: 'None' },
            { id: TimelineAxisType.DATE, text: 'Category' },
            { id: TimelineAxisType.NUMERIC, text: 'Numeric' },
        ],
        operators: [
            { id: TimelineFieldLogicalOperator.EQUAL, text: '=' },
            { id: TimelineFieldLogicalOperator.NOT_EQUAL, text: '<>' },
            { id: TimelineFieldLogicalOperator.STARTS_WITH, text: 'Starts With' },
            { id: TimelineFieldLogicalOperator.ENDS_WITH, text: 'Ends with' },
            { id: TimelineFieldLogicalOperator.CONTAINS, text: 'Contains' },
            { id: TimelineFieldLogicalOperator.DOES_NOT_CONTAIN, text: 'Does not contain' },
            { id: TimelineFieldLogicalOperator.GREATER_THAN, text: '>' },
            { id: TimelineFieldLogicalOperator.GREATER_THAN_OR_EQUAL, text: '>=' },
            { id: TimelineFieldLogicalOperator.LESS_THAN, text: '<' },
            { id: TimelineFieldLogicalOperator.LESS_THAN_OR_EQUAL, text: '<=' },
            { id: TimelineFieldLogicalOperator.IS_BLANK, text: 'Is Blank' },
            { id: TimelineFieldLogicalOperator.IS_NOT_BLANK, text: 'Is not Blank' },
        ],
        ruleOperators: [
            { id: TimelineRuleLogicalOperator.AND, text: 'And' },
            { id: TimelineRuleLogicalOperator.OR, text: 'Or' },
        ],
        booleanOperators: [
            { id: 'true', text: 'Yes' },
            { id: 'false', text: 'No' },
        ],
    };
};

const ManagePanelSplitterPanes: SplitterPaneProps[] = [{ size: '50%', max: '96%', min: '1%' }, {}];

export { getTimelinePanelListItems, ManagePanelSplitterPanes };
